// @flow

export const SERUM_BASE_URL = '/serum/render'
export const IMAGE_MODIFIERS = {
  '1:1': '&perspective=RICH&alignment=CENTER&type=image&aspect=F11',
  '3:4': '&perspective=RICH&alignment=CENTER&type=image&aspect=F34',
  '16:3': '&perspective=RICH&alignment=CENTER&type=image&aspect=F163',
  '16:9': '&perspective=RICH&alignment=CENTER&type=image&aspect=F169'
}

export const SIZE_MODIFIER = (modifier: string, base: string = '18') =>
  `&size=${modifier}&parentSize=${base}`

type Aspect = '1:1' | '3:4' | '16:3' | '16:9'

export function getSerumImageUrl(id: string, aspect: Aspect = '16:9', size: string = '18') {
  return `${SERUM_BASE_URL}?id=${id}${IMAGE_MODIFIERS[aspect]}${SIZE_MODIFIER(size)}`
}
